import React, {Fragment, useState, useEffect } from "react";
import Head from 'next/head'
import axios from 'axios'
import Header from '@/components/navbars/NavbarZero'
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { server } from "../../config";
import Container from "@mui/material/Container";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Skeleton from "@mui/material/Skeleton";
import { parseCookies } from "nookies";
import defaultImage from "../../public/images/default.jpg";
import Title from "../../components/event/title";
import Timings from "../../components/event/timings";
import Tickets from "../../components/event/tickets";
import LineUp from "../../components/event/lineup";
import AboutEvent from "../../components/event/about";
import EventTerms from "../../components/event/terms";
import EventImage from "../../components/event/image";
import EventNavBar from "../../components/navbars/Custom";
import { useRouter } from "next/router";
import RelatedEvents from '../../components/RelatedEvents'
import Footer from '@/components/common/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles'


export async function getServerSideProps(context) {
  context.res.setHeader(
    'Cache-Control',
    `public, s-maxage=1, stale-while-revalidate=${process.env.CACHE_DURATION}`
  );

  const whiteLabelUrl = context.req.headers.host


  try {
    let slug = context.params ? context.params.slug[0] : "";
    let id = context.params ? context.params.slug[1] : "";

    let res1 = await axios.get(
      `${server}/api/events/details?slug=${slug}&id=${id}`,
      {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      }
    );

    let res2 = await axios.get(
      `${server}/api/events/tickets?slug=${slug}&id=${id}`,
      {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      }
    );

    const url = `https://clubr.in/event/${slug}/${id}`;

    let cur_date_time = moment(new Date().now).format("yyyy-MM-DD hh:mm");

    const data = res1.data.result ? res1.data.result[0] : null;
    const getTickets = () => {
      let eventsTicketsArray = [];
      if (res2.data.result.length > 0) {
        eventsTicketsArray = res2.data.result.map((ticket) => {
          return `{
                "@type": "Offer",
                "availability": "https://schema.org/${
                  ticket.status == 0 || ticket.available_qty == 0
                    ? "SoldOut"
                    : ticket.days_type == "m"
                    ? moment(ticket.to_date).format("yyyy-MM-DD") +
                        " " +
                        ticket.end_time <
                      cur_date_time
                      ? "SoldOut"
                      : "InStock"
                    : moment(ticket.only_today).format("yyyy-MM-DD") +
                        " " +
                        ticket.end_time <
                      cur_date_time
                    ? "SoldOut"
                    : "InStock"
                }",
                "url": "${url}",
                "price": "${ticket.price}",
                "priceCurrency": "INR",
                "validFrom": "${ticket.eg_date.slice(0, 10)}",
                "eligibleQuantity": "${ticket.persons}",
                "category": "${ticket.title}"
              }`;
        });
      }

      return eventsTicketsArray;
    };

    const getArtists = () => {
      if (data.event_artists.length > 0) {
        const x = data.event_artists.split(",");

        const eventsArtistsArray = x.map((artist) => {
          return `{
            "@type": "Person",
            "name": "${artist}"
          }`;
        });

        return eventsArtistsArray;
      } else {
        return `{}`;
      }
    };

    const schema = `{
      "@context": "https://schema.org",
      "@type": "MusicEvent",
      "name": "${data.title ? data.title : ""}",
      "startDate": "${
        data.only_today == "0000-00-00"
          ? new Date(data.from_date).toISOString().slice(0, 10)
          : new Date(data.only_today).toISOString().slice(0, 10)
      }",
      "endDate": "${
        data.only_today == "0000-00-00"
          ? new Date(data.to_date).toISOString().slice(0, 10)
          : new Date(data.only_today).toISOString().slice(0, 10)
      }",
      "url": "${url}",
      "description": "${
        data.description.length > 15
          ? data.description
          : `Book Online Tickets, Table Reservations for ${
              data.title ? data.title : ""
            }, by ${data.clubName ? data.clubName : ""}, which is a ${
              data.event_type ? data.event_type : ""
            } event happening on ${
              data.only_today == "0000-00-00"
                ? moment(data.from_date).format("MMMM Do YYYY")
                : moment(data.only_today).format("MMMM Do YYYY")
            } at ${data.event_venue}, ${ data.is_event == 1 ? '' : data.cityName} on Clubr`
      }",
      "image": [
          "${data.img_path}"
      ],
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": "${data.clubName ? data.clubName : ""}",
        "address": {
          "@type": "PostalAddress",
          "name": "${data.event_venue ? data.event_venue : ""}",
          "streetAddress": "${data.add1 ? data.add1 : ""}",
          "addressLocality": "${data.city ? data.city : ""}",
          "postalCode": "${data.pin ? data.pin : ""}",
          "addressRegion": "${data.state ? data.state : ""}",
          "addressCountry": "${data.country ? data.country : ""}"          
        }
      },
      "performer": [${getArtists()}],
      "offers": [${getTickets()}],
      "organizer": {
        "@type": "Organization",
        "name": "${data.clubName ? data.clubName : ""}",
        "url": "${data.clubUrl ? data.clubUrl : "clubr.in"}"
      },
      "typicalAgeRange": "18-50",
      "keywords": "${
        data.event_type ? data.event_type : ""
      }, Events near me, Live Bands Near me, DJ Night, Karaoke night, Ladies night, NightClubs, Clubs near me, Concerts near me",
      "doorTime": "${data.start_time ? data.start_time : ""}"
    }`;

    const breadcrumbSchema = `{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://clubr.in"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Events",
        "item": "https://clubr.in/all-events"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "${data.title ? data.title : ""}"
      }],
      "alternateName": "${data.event_type ? data.event_type : ""}",
      "description": "${data.description ? data.description : ""}",
      "image": "${data.img_path ? data.img_path : defaultImage}",
      "url": "${url}"
    }`;

    return {
      props: {
        event: res1.data.result ? res1.data.result[0] : null,
        tickets: res2.data ? res2.data.result : null,
        slug: slug,
        id: id,
        url: whiteLabelUrl,
        breadcrumbSchema: breadcrumbSchema,
        schema: schema,
      },
    };
  } catch (e) {
    console.log(e);
  }

  // return {
  //   props: {
  //     res,
  //   }
  // }

}

function Slug(props) {
  const [slug, setslug] = useState(props.slug);
  const [id, setid] = useState(props.id);
  const [data, setData] = useState(props.event);
  const [tickets, setTickets] = useState(props.tickets);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEventActive, setisEventActive] = useState(0);
  const [cityName, setCityName] = useState("");
  const cookieCity = parseCookies();
  const [eventUrl, setEventUrl] = useState(null);
  const Router = useRouter();

  const theme = useTheme();
  const [themeCss, setThemeCss] = useState(null)
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();

  const eventPageContainer = {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
    },
  
    "& h1": {
      fontSize: 25,
      color: theme.palette.grey[200],
      fontWeight: 500,
      marginBottom: theme.spacing(0.5),
    },
    "& h4": {
      fontSize: 12,
      color: theme.palette.grey[200],
      fontWeight: 400,
      marginBottom: theme.spacing(0.5),
    },
    "& h5": {
      fontSize: 15,
      textTransform: "uppercase",
      color: theme.palette.primary.dates,
      fontWeight: 400,
    },
    "& h6": {
      fontSize: 16,
      color: theme.palette.primary.location,
      fontWeight: 400,
    },
    "& .menuTitle": {
      fontSize: 12,
      color: theme.palette.grey[200],
      fontWeight: 400,
      textTransform: "uppercase !important",
      marginBottom: theme.spacing(0.5),
    },
  };


  useEffect(()=>{
    changeUrl(props.url)
  },[url]);

  useEffect(()=>{
    let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
    setThemeCss(custom_css);
    setLoading(false);    
  }, [themeData, siteData]);

  // useEffect(()=>{
  //   if(props.event.restaurent_id != (siteData && siteData.club_inner[0].clubId)){
  //     Router.push('/404')
  //   }
  // },[props.event])
  

  const styles = {
    body: {
      backgroundColor: theme.palette.background.default,
      contrastText: theme.palette.primary.contrastText,
    },
  };

  useEffect(()=>{
    AOS.init();
    AOS.refresh();
    document.body.style.backgroundColor = styles.body.backgroundColor;
    document.body.style.color = styles.body.contrastText;
  },[]);


  useEffect(() => {
    if (props.slug !== props.event.slug) {
      Router.push("/event/" + props.event.slug + "/" + props.event.id);
    }

    setData(props.event);
    setTickets(props.tickets);
    setslug(props.slug);
    setid(props.id);
    setEventUrl(window.location.href);

    if (document.getElementById("paytm-checkoutjs")) {
      document.getElementById("paytm-checkoutjs").style.display = "none";
    }

    const x = props.event ? props.event : [];
    // if (x.length > 0) {
    const date = moment(x.only_today == "0000-00-00" ? x.to_date : x.only_today)
      .format()
      .slice(0, 10);
    const time = x.end_time;
    const eventLastDateTime = new Date(date + "T" + time);
    const curDate = new Date();

    if (eventLastDateTime >= curDate) {
      setisEventActive(1);
    } else {
      setisEventActive(0);
    }
    // }
    const checkEventStatus = async () => {
      let res = await axios.get(
        `/api/events/details?slug=${props.slug}&id=${props.id}`,
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      );

      const x = res.data.result ? res.data.result[0] : [];
      // if (x.length > 0) {
      const date = moment(
        x.only_today == "0000-00-00" ? x.to_date : x.only_today
      )
        .format()
        .slice(0, 10);
      const time = x.end_time;
      const eventLastDateTime = new Date(date + "T" + time);
      const curDate = new Date();

      if (eventLastDateTime >= curDate) {
        setisEventActive(1);
      } else {
        setisEventActive(0);
      }
      // }
    };
    checkEventStatus();
  }, [props]);

  // --------------------- TRIBE RELATED CODE STARTS ---------------------------------------------
  const [uniqueID, setUniqueId] = useState(null);
  // --------------------- TRIBE RELATED CODE ENDS ---------------------------------------------

  useEffect(() => {
    const url_string = window.location.href;
    const new_url_string = new URL(url_string);
    const uniqueId = new_url_string.searchParams.get("unique_id");
    if (uniqueId != null) {
      setUniqueId(uniqueId);
      console.log("COMING THROUGH AFFILIATE URL");
      // console.log(window.location.pathname);
      const a = window.location.href.split("/");
      // console.log(`/${a[3]}/${a[4]}/${a[5]}`);
      const redirectUrl = `/${a[3]}/${a[4]}/${a[5]}`;
      localStorage.setItem(
        "affiliateData",
        JSON.stringify({
          url: `${window.location.protocol}//${window.location.hostname}${
            window.location.hostname == "localhost" ? ":3000" : ""
          }${redirectUrl}`,
          expiryTime: new Date(),
        })
      );
      if (!sessionStorage["first_visit"]) {
        // console.log('first visit true...');
        axios
          .get(`/api/tribe/addView?eventId=${id}&uniqueId=${uniqueId}`, {
            headers: {
              "x-auth-token": process.env.JWT_TOKEN,
            },
          })
          .then((response) => {
            // console.log(response.data);
            // console.log('UNIQUE ID: ', uniqueId);
            sessionStorage.setItem("first_visit", 1);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      if (localStorage["affiliateData"]) {
        // console.log('COMING THROUGH LOCAL STORAGE');
        const expiryTime = JSON.parse(
          localStorage.getItem("affiliateData")
        ).expiryTime;
        const now = new Date();

        if (now - expiryTime >= 2592000000) {
          // 2592000000 is 30 days in miliseconds
          localStorage.removeItem("affiliateData");
          // console.log('LOCAL STORAGE EXPIRED');
        } else {
          const affiliateUrlLS = JSON.parse(
            localStorage.getItem("affiliateData")
          ).url;
          // let eventIdLS = new URL(affiliateUrlLS).pathname.split('/')[3];
          // let eventIdLS = affiliateUrlLS.split('/')[3];
          let eventIdLS = affiliateUrlLS.split("/")[5].split("?")[0];
          // console.log(affiliateUrlLS.split('/')[5].split('?')[0]);

          if (
            new URL(window.location.href).pathname.split("/")[3] == eventIdLS
          ) {
            // console.log('AFFILIATE EVENT ID MATCHED');
            if (!sessionStorage["first_visit"]) {
              const url_string = JSON.parse(
                localStorage.getItem("affiliateData")
              ).url;
              const new_url_string = new URL(url_string);
              const uniqueId = new_url_string.searchParams.get("unique_id");
              setUniqueId(uniqueId);
              axios
                .get(`/api/tribe/addView?eventId=${id}&uniqueId=${uniqueId}`, {
                  headers: {
                    "x-auth-token": process.env.JWT_TOKEN,
                  },
                })
                .then((response) => {
                  sessionStorage.setItem("first_visit", 1);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        }
      }
    }
  }, []);

  let ticketStatus = props.tickets.some((ticket) => ticket.status == 1);
  let reserveStatus = props.tickets.some(
    (ticket) => ticket.price > 0 && ticket.status == 1
  );

  if (props.tickets.length) {
    props.tickets.sort(function (a, b) {
      return a.price - b.price;
    });
  }

  var starting = props.tickets.length > 0 ? props.tickets[0].price : 0;

  let cur_date = moment(new Date().now).format("YYYY-MM-DD");
  let cur_date_status = 1;
  if (data.only_today != "0000-00-00") {
    if (cur_date <= data.only_today) {
      cur_date_status = 0;
    }
  } else {
    if (cur_date <= data.end_date) {
      cur_date_status = 0;
    }
  }


  return (
    <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>{`${data.title ? data.title : ""} by ${
        data.clubName ? data.clubName : ""
      }, ${data.event_type ? data.event_type : ""} Event Tickets ${
        data.is_event == 1 ? '' : data.cityName
      } - Clubr`}</title>
      <meta
        name="description"
        content={`Book Online Tickets, Table Reservations for ${
          data.title ? data.title : ""
        }, by ${data.clubName ? data.clubName : ""}, which is a ${
          data.event_type ? data.event_type : ""
        } event happening on ${
          data.only_today == "0000-00-00"
            ? moment(data.from_date).format("MMMM Do YYYY")
            : moment(data.only_today).format("MMMM Do YYYY")
        } at ${data.event_venue ? data.event_venue : ""} ${data.is_event == 1  ? '' : 
          data.cityName ? data.cityName : "" 
        } on Clubr`}
      ></meta>
      <meta
        property="og:title"
        content={`${data.title ? data.title : ""} by ${
          data.clubName ? data.clubName : ""
        }, ${data.event_type ? data.event_type : ""} Event Tickets ${data.is_event == 1 ? '' : 
          data.cityName ? data.cityName : ""
        } - Clubr`}
      />
      <meta
        property="og:description"
        content={`Book Online Tickets, Table Reservations for ${
          data.title ? data.title : ""
        }, by ${data.clubName}, which is a ${
          data.event_type ? data.event_type : ""
        } event happening on ${
          data.only_today == "0000-00-00"
            ? moment(data.from_date).format("MMMM Do YYYY")
            : moment(data.only_today).format("MMMM Do YYYY")
        } at ${data.event_venue}, ${data.is_event == 1 ? '' : data.cityName} on Clubr`}
      />
      <meta
        property="og:image"
        content={data.img_path ? data.img_path : defaultImage}
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Clubr" />
      <meta
        property="og:url"
        content={`https://clubr.in/event/${data.slug ? data.slug : ""}/${
          data.id ? data.id : ""
        }`}
      />

      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta name="twitter:site" content="@Clubr14"></meta>
      <meta name="twitter:creator" content="@Clubr14"></meta>
      <meta
        name="twitter:title"
        content={`${data.title ? data.title : ""} by ${
          data.clubName ? data.clubName : ""
        }, ${data.event_type ? data.event_type : ""} Event Tickets ${ data.is_event == 1 ? '' :
          data.cityName ? data.cityName : ""
        } - Clubr`}
      ></meta>
      <meta
        name="twitter:description"
        content={`Book Online Tickets, Table Reservations for ${
          data.title ? data.title : ""
        }, by ${data.clubName}, which is a ${
          data.event_type ? data.event_type : ""
        } event happening on ${
          data.only_today == "0000-00-00"
            ? moment(data.from_date).format("MMMM Do YYYY")
            : moment(data.only_today).format("MMMM Do YYYY")
        } at ${data.event_venue ? data.event_venue : ""}, ${ data.is_event == 1 ? '' :
          data.cityName ? data.cityName : ""
        } on Clubr`}
      ></meta>
      <meta
        name="twitter:image"
        content={data.img_path ? data.img_path : defaultImage}
      ></meta>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: props.schema }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: props.breadcrumbSchema }}
      />
    </Head>
    <Typography component={'div'} className="desktopMode">
      <Header />
    </Typography>
    <Container maxWidth="lg">
      {loading ? (
        <Container>
          <Typography component="div" className="main_sec">
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={300}
                  sx={{ borderRadius: "20px", color: "grey.900" }}
                />
                <Stack
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    mt: 3,
                    mb: 3,
                  }}
                >
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{ color: "grey.900", mr: 2 }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{ color: "grey.900" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                <Skeleton
                  animation="wave"
                  variant="h1"
                  height={35}
                  sx={{ color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="body1"
                  width={200}
                  sx={{ mt: 1, color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="h3"
                  width="55%"
                  sx={{ mt: 3, color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="h2"
                  height={100}
                  sx={{ borderRadius: "20px", mt: 3, color: "grey.900" }}
                />
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Stack sx={{ display: "flex", flexDirection: "row" }}>
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                </Stack>
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Typography>
        </Container>
      ) : (
        // className='inner-page'
        <Fragment>  
          {/* <Head></Head> */}
          <Typography
            component="div"
            sx={eventPageContainer}
            className={"main_sec"}
          >
           
            <Typography component="div" className="mobileMode">
              <EventNavBar
                title={props.event.title}
                url={"/events"}
              />
            </Typography>
            <Grid container>
              {/* <Grid item xs={12} lg={5} md={5} sm={12} data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <EventImage data={data} url={url} />
              </Grid> */}
              <Grid item xs={12} lg={5} md={5} sm={12} >
                <EventImage data={data} url={eventUrl} />
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                md={6}
                sm={12}
                sx={{
                  pl: {
                    md: 5,
                  },
                  mt: {
                    md: 2,
                    sm: 0,
                  },
                }}
                // data-aos="fade-up" data-aos-duration="1000"  data-aos-offset="100"
              >
                <Title data={data} url={url} />
                <Timings data={data} />
                {/* <Venue data={data} /> */}
                <Tickets
                  data={data}
                  isEventActive={isEventActive}
                  tickets={props.tickets}
                  ticketStatus={ticketStatus}
                  reserveStatus={reserveStatus}
                  starting={starting}
                  uniqueId={uniqueID}
                />
                {data.event_artists ? (
                  <LineUp data={data} artists={props.artists} />
                ) : (
                  ""
                )}
                {data ? <AboutEvent data={data} /> : ""}
                {(data.tc && data.tc.length) > 0 ? (
                  <EventTerms data={data} />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            <Typography
              component="div"
              sx={{
                py: {
                  md: 4,
                  sm: 0,
                  xs: 0,
                },
              }}
              // data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100"
            >
              <RelatedEvents id={id} slug={slug} />
            </Typography>
          </Typography>
        </Fragment>
      )}
    </Container>
    <Footer />
    </>
  );
}

export default Slug;
